<template>
    <div>
        <div class="card card-gg">
            <div class="card-header">Contact Information</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-row">
                            <div class="col form-group">
                                <label for="firstName">First Name</label>
                                <input type="text" class="form-control" id="firstName" name="first_name"
                                       v-model="form.first_name" />
                                <form-errors :errors="form.errors" field="first_name"></form-errors>
                            </div>
                            <div class="col form-group">
                                <label for="lastName">Last Name</label>
                                <input type="text" class="form-control" id="lastName" name="last_name"
                                       v-model="form.last_name" />
                                <form-errors :errors="form.errors" field="last_name"></form-errors>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input type="email" class="form-control" id="email" v-model="form.email" />
                            <form-errors :errors="form.errors" field="email"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="dob">Birthday</label>
                            <t-datepicker id="dob" v-model="form.dob"></t-datepicker>
                            <form-errors :errors="form.errors" field="dob"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="position">Title</label>
                            <input type="text" class="form-control" id="position" name="position"
                                   v-model="form.position" />
                            <form-errors :errors="form.errors" field="position"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="business_phone">Business Phone</label>
                            <input type="text" class="form-control" id="business_phone" name="business_phone"
                                   v-model="form.business_phone" />
                            <form-errors :errors="form.errors" field="business_phone"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="phone">Mobile Phone <small class="ml-2 optional">Optional</small></label>
                            <input type="text" class="form-control" id="phone" name="phone" v-model="form.phone" />
                            <form-errors :errors="form.errors" field="phone"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="website">Website <small class="ml-2 optional">Optional</small></label>
                            <input type="text" class="form-control" id="website" name="website"
                                   v-model="form.website" />
                            <form-errors :errors="form.errors" field="website"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="timezone">Timezone</label>
                            <t-form-select
                                group-label="region"
                                group-options="zones"
                                id="timezone"
                                name="timezone"
                                placeholder="Timezone"
                                v-model="form.timezone"
                                :options="timezoneOptions"
                            >
                            </t-form-select>
                            <form-errors :errors="form.errors" field="timezone"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="billing_address">Business Address</label>
                            <input type="text" class="form-control" id="billing_address" name="billing_address"
                                   v-model="form.billing_address" />
                            <form-errors :errors="form.errors" field="billing_address"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="billing_address_line_2">Business Address Line 2</label>
                            <input type="text" class="form-control" id="billing_address_line_2"
                                   name="billing_address_line_2" v-model="form.billing_address_line_2" />
                            <form-errors :errors="form.errors" field="billing_address_line_2"></form-errors>
                        </div>
                        <div class="form-group">
                            <label for="billing_country">Country</label>
                            <country-picker id="billing_country" name="billing_country" placeholder="Country"
                                            v-model="form.billing_country" />
                            <form-errors :errors="form.errors" field="billing_country"></form-errors>
                        </div>
                        <div class="form-group">
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col">
                        <label for="billing_state">State</label>
                        <state-picker :country="form.billing_country" id="billing_state" name="State"
                                      placeholder="billing_state" v-model="form.billing_state" />
                        <form-errors :errors="form.errors" field="billing_state"></form-errors>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label for="billing_zip">Zip</label>
                            <input type="text" class="form-control" id="billing_zip" name="billing_zip"
                                   v-model="form.billing_zip" />
                            <form-errors :errors="form.errors" field="billing_zip"></form-errors>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <button @click="save" type="submit" class="btn btn-primary">
                        Update
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pick from 'lodash/pick';
import CountryPicker from '@/shared/CountryPicker.vue';
import StatePicker from '@/shared/StatePicker.vue';
import { FormErrors } from '@jgile/laravel-vue';

export default {
    components: { CountryPicker, StatePicker, FormErrors },
    props: {
        user: {
            required: true,
        },
        timezoneOptions: {
            required: true,
        },
    },
    data() {
        return {
            form: new SparkForm(pick(this.user, [
                'email',
                'dob',
                'position',
                'timezone',
                'business_phone',
                'phone',
                'website',
                'first_name',
                'last_name',
                'settings',
                'billing_address',
                'billing_address_line_2',
                'billing_city',
                'billing_state',
                'billing_zip',
                'billing_country',
            ])),
        };
    },
    methods: {
        save() {
            Spark.put('/api/users/settings', this.form);
        },
    },
};
</script>
